interface ProgressBarProps {
  previousProgress: number;
  currentProgress: number;
}

export function ProgressBar({
  previousProgress,
  currentProgress,
}: ProgressBarProps): JSX.Element {
  return (
    <div className="absolute bottom-0 left-0 right-0 h-1 overflow-hidden rounded-b-md">
      <div className="h-full flex">
        <div
          className="bg-blue-300"
          style={{
            width: `${Math.min(previousProgress, currentProgress)}%`,
          }}
        />
        <div
          className={
            currentProgress > previousProgress ? 'bg-blue-500' : 'bg-red-500'
          }
          style={{
            width: `${Math.abs(currentProgress - previousProgress)}%`,
          }}
        />
      </div>
    </div>
  );
}
